import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/api/client";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=loading, false=anon, obj=auth
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      } finally {
        setReady(true);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("fah_token", data.token);
    setUser(data.user);
    return { user: data.user, autoRegistered: !!data.auto_registered };
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data.token) localStorage.setItem("fah_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const otpLogin = async (phone, otp, name) => {
    const { data } = await api.post("/auth/otp/verify", { phone, otp, name });
    if (data.token) localStorage.setItem("fah_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("fah_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, otpLogin, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
